import { Component } from 'preact'
/* eslint-disable import/no-internal-modules */
import Header from '@insided/deprecated-control/header'
import AlertBox, { MessageTypes } from '@insided/deprecated-preact-components/design-system-components/message'
import GeneralPanel, {
  checkInputValidation,
  ErrorSchemaForSlug,
  ErrorSchemaForTitle,
  FieldsErrorType,
  INVALID_SLUG_GENERIC_MESSAGE,
  INVALID_TITLE_GENERIC_MESSAGE
} from './GeneralPanel'
import SEOPanel from './SEOPanel'
import { Permission, Role, RoleList } from './interfaces'
import { mapRolesToPermissions } from './utils'
import axios from 'axios'

interface State extends FieldsErrorType {
  title: string
  slug: string
  metaName: string
  metaDescription: string
  alertMessage: string
  alertMessageType?: null | MessageTypes
  loading: boolean
  slugError: boolean
  permissions: Permission[]
}

export class CustomPageAdd extends Component<{ roles: RoleList }, State> {
  constructor() {
    super()
    this.state = {
      title: '',
      slug: '',
      metaName: '',
      metaDescription: '',
      alertMessage: '',
      alertMessageType: null,
      permissions: [],
      fieldsError: {
        title: null,
        slug: null
      },
      slugError: false,
      loading: false
    }

    this.createNewCustomPage = this.createNewCustomPage.bind(this)
    this.handleVisibilitySettingsChange = this.handleVisibilitySettingsChange.bind(this)
  }

  async createNewCustomPage() {
    const { title, slug, metaName, metaDescription, permissions } = this.state
    const slugError = checkInputValidation(ErrorSchemaForSlug, slug, INVALID_SLUG_GENERIC_MESSAGE)
    const titleError = checkInputValidation(ErrorSchemaForTitle, title, INVALID_TITLE_GENERIC_MESSAGE)
    if (titleError || slugError) {
      this.setState({
        fieldsError: {
          title: titleError,
          slug: slugError
        }
      })
      return
    }

    try {
      this.setState({
        loading: true
      })

      const response = await axios.post(
        '/platform/custom-pages/new',
        {
          title,
          slug: encodeURI(slug.replace(/^\//g, '')),
          seo_fields: {
            name: metaName,
            description: metaDescription
          },
          permissions
        },
        {
          validateStatus: (state: number) => {
            return (state >= 200 && state < 300) || state === 422
          }
        }
      )
      this.setState({
        loading: false
      })
      if (response.status === 422) {
        this.setState({
          alertMessageType: 'error',
          alertMessage: response.data.error
        })
      } else {
        window.location.assign('/platform/custom-pages?success=true')
      }
    } catch (e) {
      this.setState({
        loading: false,
        alertMessageType: 'error',
        alertMessage: 'Something went wrong'
      })
    }
  }

  handleVisibilitySettingsChange(selectedRoles: Role[]) {
    const { mainRoles, customRoles } = this.props.roles
    this.setState({ permissions: mapRolesToPermissions(selectedRoles, [...mainRoles, ...customRoles]) })
  }

  render() {
    const { alertMessageType, alertMessage, fieldsError, loading } = this.state
    const { roles } = this.props

    return (
      <div className='custom-pages-new-page'>
        {alertMessageType && (
          <AlertBox
            isControl
            variant={alertMessageType}
            onDismiss={() => this.setState({ alertMessageType: null })}
            timer={3000}
          >
            {alertMessage}
          </AlertBox>
        )}
        <Header
          title='New Page'
          hasBreadcrumb
          isLoading={loading}
          breadcrumbText='Back to Custom Pages Main'
          breadcrumbLink='/platform/custom-pages'
          saveCallback={this.createNewCustomPage}
          cancelCallback={() => {
            window.location.href = '/platform/custom-pages'
          }}
        />
        <GeneralPanel
          title=''
          slug=''
          fieldsError={fieldsError}
          roles={roles}
          onTitleChange={(value) => this.setState({ title: value })}
          onSlugChange={(value) => this.setState({ slug: value })}
          onVisibilitySettingsChange={this.handleVisibilitySettingsChange}
        />
        <SEOPanel
          name=''
          description=''
          onNameChange={(value) => this.setState({ metaName: value })}
          onDescriptionChange={(value) => this.setState({ metaDescription: value })}
        />
      </div>
    )
  }
}

export default CustomPageAdd
